function isWithinLast30Days(inputDate) {
  if (!inputDate) {
    return false;
  }

  const dateToCheck = new Date(inputDate);
  const daysTillToday = (date) =>
    Math.floor((new Date() - date) / (1000 * 60 * 60 * 24));

  return daysTillToday(dateToCheck) <= 30;
}

module.exports = isWithinLast30Days;
